// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"city-11"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21 21V13L15 11L9 13V21H21Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M13 3V11.6667L9 13V21H3V3H13Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15 17V21M13 11.6667V3H3V21H9V13L13 11.6667Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 21V13L15 11L9 13V21H21Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const City11Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'city-11',
    ref,
    icon: element,
  },
));

City11Icon.displayName = 'City11Icon';

export default City11Icon;
